import { render, staticRenderFns } from "./CreateFranchise.vue?vue&type=template&id=77739ce2&scoped=true"
import script from "./CreateFranchise.vue?vue&type=script&lang=js"
export * from "./CreateFranchise.vue?vue&type=script&lang=js"
import style0 from "./CreateFranchise.vue?vue&type=style&index=0&id=77739ce2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77739ce2",
  null
  
)

export default component.exports